<template>
  <div class="compare-groups-selector">
    <div class="compare-groups-selector__config">
      <DropDown
        :list-items="pageGroups"
        :limit="maxNumberOfGroups"
        @options-list="setOptionsList"
        @input-focus="trackFocusInList"
      />

      <VSelect
        id="channel"
        v-model="channel"
        outlined
        dense
        :menu-props="{ botton: true, offsetY: true }"
        :items="getOptions"
        :label="$t('Benchmarks.pages.compare.select.label')"
        @focus="trackOpenCloseDropdownSocialNetwork"
        @blur="trackOpenCloseDropdownSocialNetwork"
        @change="trackSelectedDropdownSocialNetwork"
      />

      <div>
        <DsButton
          :disabled="!hasCompare"
          @click="compareGroup"
        >
          {{ $t("Benchmarks.pages.compare.button") }}
        </DsButton>
      </div>
    </div>
  </div>
</template>

<script>
import { MAX_NUMBER_OF_GROUPS, dispatchMixpanelTrack } from '@/utils';

import { DsButton } from '@ds/components';
import { DropDown } from '@/components/base';

export default {
  name: 'CompareGroupsSelector',
  components: {
    DropDown,
    DsButton,
  },
  data() {
    return {
      maxNumberOfGroups: MAX_NUMBER_OF_GROUPS,
      listItems: [],
      hasCompare: false,
      channel: this.$t('Benchmarks.pages.compare.select.firstOption'),
      compareList: [],
    };
  },
  computed: {
    pageGroups() {
      return this.$store.getters['benchmarks/pageGroups'];
    },
    getOptions() {
      return [
        this.$t('Benchmarks.pages.compare.select.firstOption'),
        ...this.$store.getters['benchmarks/channelsLabels'],
      ];
    },
  },
  watch: {
    listItems() {
      if (this.listItems.length < 1) {
        this.$store.dispatch('ui/addGroupList', []);
        this.compareList = [];
        this.hasCompare = false;

        this.emitOnHasComparison();
        this.emitOnEnableShowChartsTabs(false);

        return;
      }

      if (this.compareList === 0) {
        this.compareList = this.listItems;
      }
    },
  },
  methods: {
    setOptionsList({ source, list }) {
      this.listItems = list;
      this.hasCompare = list.length >= 2;
      this.emitOnHasComparison();

      if (source === 'inside') {
        dispatchMixpanelTrack('BM SelectPageGroup Dropdown Open/Close', ['network'], {
          answer: 'arrow',
        });
      }
    },
    trackFocusInList() {
      dispatchMixpanelTrack('BM SelectPageGroup Dropdown Click', ['network'], {
        answer: 'input',
      });
    },
    trackOpenCloseDropdownSocialNetwork() {
      dispatchMixpanelTrack('BM Social Midia Dropdown Open/Close', ['network', 'groups', 'tab'], {
        answer: this.compareList.length,
      });
    },
    trackSelectedDropdownSocialNetwork() {
      dispatchMixpanelTrack('Social Midia Select Social Midia Click', ['network', 'groups', 'tab'], {
        answer: this.compareList.length,
      });
    },
    handleChannelSelected() {
      this.$store.dispatch('ui/addChannel', this.channel === 'Todas as redes' ? 'Todas' : this.channel);
    },
    emitOnHasComparison() {
      this.$emit('onHasComparison', this.hasCompare);
    },
    emitOnEnableShowChartsTabs(value) {
      this.$emit('onEnableShowChartTabs', value);
    },
    compareGroup() {
      this.$store.dispatch('ui/addGroupList', this.listItems);

      this.compareList = this.listItems;

      this.emitOnEnableShowChartsTabs(true);
      this.handleChannelSelected();

      this.$emit('onCompareGroupsClick');

      dispatchMixpanelTrack('BM BrandPicker Button On/Off', ['network']);
      dispatchMixpanelTrack('BM SelectPageGroup CompareButton On/Off', ['network', 'groups'], {
        answer: this.compareList.length,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.compare-groups-selector {
  width: 100%;
  text-align: right;

  &__config {
    display: grid;
    grid-template-columns: 1fr 207px 126px;
    column-gap: var(--ds-spacing-stack-xs);
  }
}
</style>
